export const serverUrl = process.env.NODE_ENV === 'production'
//   ? 'https://apilgcy.bol.cl/api/'
  ? 'https://app.bodegaenlinea.cl/api/'
  : 'http://localhost:8000/api/'

export const serverUrlAR = 'https://sync.bol.cl/importDF/'
export const accessToken = 'adsadsdfjasuhdfkuyasdgbyghr43q7f2ugwhuas'